'use client';

import { useEffect } from 'react';
import { trackException } from '@/lib/monitoring/appInsights';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    trackException(error);
  }, [error]);

  return (
    <html lang="da">
      <body
        style={{
          margin: 0,
          fontFamily: 'Poppins, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 600,
            color: 'var(--color-brand-dark, #192553)',
            marginBottom: '1rem',
          }}
        >
          Noget gik galt
        </h1>
        <p
          style={{
            color: 'var(--foreground, #6b7280)',
            marginBottom: '1.5rem',
            maxWidth: '28rem',
          }}
        >
          Der opstod en kritisk fejl. Prøv venligst at genindlæse siden.
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'var(--color-brand-dark, #192553)',
            color: 'var(--color-brand-white, #fff)',
            border: '2px solid transparent',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: 500,
            outline: 'none',
          }}
          onFocus={(e) => { e.currentTarget.style.boxShadow = '0 0 0 3px var(--color-brand-teal, #47e1c2)'; }}
          onBlur={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
        >
          Genindlæs
        </button>
      </body>
    </html>
  );
}
